module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('title-block', {
    attrs: {
      "title": "Sections Beyond Oncology",
      "color-theme": "primary-color"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-6 color0"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Gerotaget / Aging")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida\n          dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque\n          penatibus et magnis dis parturient montes, nascetur ridiculus mus. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 color1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Pathology beyond Oncology")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida\n          dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.\n          Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 color2"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Immunology & Microbiology")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida\n          dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque\n          penatibus et magnis dis parturient montes, nascetur ridiculus mus. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 color3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Autophagy & Cell Death")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida\n          dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque\n          penatibus et magnis dis parturient montes, nascetur ridiculus mus. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 color4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Chromosome")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida\n          dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque\n          penatibus et magnis dis parturient montes, nascetur ridiculus mus. ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50ba058a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/SectionsBeyondOncologyComponent.vue
// module id = 1430
// module chunks = 1